import jp from 'jsonpath';
import getFormLocal from './getFormLocal';

export default function getQuestions(formId, sectionId) {
  return new Promise((resolve) => {
    getFormLocal(formId).then((form) => {
      resolve(jp.query(form, `$.inspection.children.${sectionId}.children[*]`));
    });
  });
}
